"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.progress.title': 'Entrenamiento del Modelo',
    'trainer.progress.start': 'Iniciar Entrenamiento',
    'trainer.progress.stop': 'Detener Entrenamiento',
    'trainer.progress.new': 'Nuevo Entrenamiento',
    'trainer.progress.title.text': 'Progreso del Entrenamiento',
    'trainer.progress.metric.epoch': 'Época Actual:',
    'trainer.progress.metric.loss': 'Pérdida:',
    'trainer.progress.metric.accuracy': 'Precisión:',
    'trainer.progress.metric.time': 'Tiempo Restante:',
};
